// eslint-disable-next-line import/prefer-default-export
export function wordsSearch(input, words) {
  return words.some((word) => new RegExp(word, 'i').test(input))
}
